'use strict';

const {jQuery} = window;

/**
 * @param {*} any
 * @returns {Boolean}
 */
export const {isNaN} = window;
/**
 * @param {*} any
 * @returns {Boolean}
 */
export function isObject(any) {
  return any !== null && typeof any === 'object';
}
/**
 * @param {*} any
 * @returns {Boolean}
 */
export const {isArray} = Array;
/**
 * @param {Array<Object>} array
 * @param {Function} [getterKey=getterId]
 * @returns {{}}
 */
export function toObject(array, getterKey = getterId) {
  let object = {};
  for(let item of array) {
    let key = getterKey(item);
    object[key] = item;
  }
  return object;
}
function getterId(object) {
  return object['id'];
}
/**
 * @param {Object|String} containerElementOrSelector
 * @param {Object|String} anchorElementOrSelector
 * @param {Number} [duration=500]
 * @param {Number} [delay=0]
 */
export function scroll(containerElementOrSelector, anchorElementOrSelector, duration=500, delay=0) {
  let cb = function () {
    let $element = jQuery(anchorElementOrSelector);
    let offset = $element.offset();
    jQuery(containerElementOrSelector).animate({scrollTop: offset.top}, duration);
  };
  setTimeout(cb, delay);
}
/**
 * @param {Number|String} n
 * @returns {String}
 */
export function currency(n) {
  return String(n).replace(currency.PATTERN, ' ');
}
currency.PATTERN = /(?=\B(?:\d{3})+\b)/g;
/**
 * @param {Number} n
 * @returns {Number}
 */
export function percent(n) {
  return n * 100;
}
/**
 * @param {Number} n
 * @param {Number} [digits=0]
 * @returns {String}
 */
export function fixed(n, digits = 0) {
  let m = Math.pow(10, digits);
  let k = Math.round(n * m) / m;
  return k.toFixed(digits);
}


// WEBPACK FOOTER //
// ./src/js/lang.js